import { render, staticRenderFns } from "./CheckoutSummary.vue?vue&type=template&id=49c74d6f"
import script from "./CheckoutSummary?vue&type=script&lang=ts&external"
export * from "./CheckoutSummary?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports